<template>
  <div class="docsDetail">
    <el-card shadow="never">
      <div class="body">
        <div class="titolo col-24">{{ doc.container === undefined ? '&nbsp' : $i18n.t('docs.documentType.' +
          doc.container + '.label') }}</div>
        <div class="testo col-24">{{ getTitolo(doc) }}</div>
        <div class="data col-24">{{ getDate(doc) }}</div>
      </div>
      <div class="icon" @click="getDoc(doc)">
        <icon name="riv-pdfOro" scale="2"></icon>
      </div>
    </el-card>
  </div>
</template>

<script>
import mixinDownload from "../../assets/mixins/downloadDoc.js";

export default {
  name: 'GridDoc',
  mixins: [mixinDownload],
  props: ['doc', 'showInDashboard'],
  data() {
    return {
      baseUrl: process.env.baseUrl
    }
  },
  i18n: {},
  computed: {
    homeStyle: function () {
      let path = this.$route.path
      return (path.indexOf('/documenti/') !== 0)
    }
  },
  mounted: function () {
  },
  methods: {
    getTitolo: function (doc) {
      if (doc.container === undefined) {
        return doc.oggetto
      } else if (doc.container == 'PAFPAGLETGEN') {
        return doc.tdo
      } else if (doc.container == 'RIVPDEDOCPER' || doc.container == 'RIVPDELETINF') {
        return doc.tit
      } else {
        return ''
      }
    },
    getDate: function (doc) {
      if (doc.container === undefined) {
        return ''
      } else if (doc.container == 'PAFPAGLETGEN') {
        return this.$i18n.t('el.datepicker.month' + parseInt(doc.mese)) + ' ' + doc.anno
      } else if (doc.container == 'RIVPDEDOCPER' || doc.container == 'RIVPDELETINF') {
        return doc.datada
      } else if (doc.container == 'PAIPAGMODCUD') {
        return doc.anno
      } else {
        return this.$i18n.t('el.datepicker.month' + parseInt(doc.mese)) + ' ' + doc.anno
      }
    },
    getNome: function (doc) {
      if (doc.container === undefined) {
        return doc.oggetto
      } else if (doc.container == 'PAFPAGLETGEN') {
        let nome = this.$i18n.t('docs.documentType.' + doc.container + '.label') + + ' ' + doc.tdo
        return nome + ' ' + this.$i18n.t('el.datepicker.month' + parseInt(doc.mese)) + ' ' + doc.anno
      } else if (doc.container == 'RIVPDEDOCPER' || doc.container == 'RIVPDELETINF') {
        return '[' + doc.datada + ']' + ' ' + doc.tit
      } else if (doc.container == 'PAIPAGMODCUD') {
        let nome = this.$i18n.t('docs.documentType.' + doc.container + '.label')
        return nome + ' ' + doc.anno
      } else if (doc.container === undefined) {
        return 'generic'
      } else {
        let nome = this.$i18n.t('docs.documentType.' + doc.container + '.label')
        return nome + ' ' + this.$i18n.t('el.datepicker.month' + parseInt(doc.mese)) + ' ' + doc.anno
      }
    },
    getNomeUrl: function (doc) {
      if (doc.container == 'PAFPAGLETGEN') {
        let nome = this.$i18n.t('documentType.' + doc.container + '.label', { titolo: '' })
        return nome + ' ' + this.$i18n.t('el.datepicker.month' + parseInt(doc.mese)) + ' ' + doc.anno
      } else if (doc.container == 'RIVPDEDOCPER' || doc.container == 'RIVPDELETINF') {
        return '[' + doc.datada + ']' + ' ' + doc.tit
      } else {
        let nome = this.$i18n.t('documentType.' + doc.container + '.label')
        return nome + ' ' + this.$i18n.t('el.datepicker.month' + parseInt(doc.mese)) + ' ' + doc.anno
      }
    }
  }
}
</script>

<style lang="less">
@import "../../assets/less/general.less";

.docsDetail {
  .padding-2 {
    padding-left: 3px;
    padding-right: 3px;
  }

  .el-card {
    width: 100%;
    height: 80px;
    float: left;
    margin-bottom: 10px;
    border-radius: 0px;
    padding: 5px 10px !important;

    .el-card__body {
      padding: 0;
      height: 100%;

      .body {
        width: 80%;
        float: left;
        text-align: left;

        //padding-right: 5px;
        .titolo {
          width: 80%;
          .set-font(@family: 'os-semibold', @color: #103e9a, @size: 16px);
          text-align: left;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .testo {
          height: 20px;
          // padding: 0 5px !important;
          .set-font(@size: 12px; @color: @textTable);
          text-align: left;
          word-break: break-word;
        }

        .data {
          .set-font(@color: #9AA0A7, @size: 12px);
          margin-top: 15px;
          text-align: left;
          //font-style: italic;
        }
      }

      .icon {
        height: 102px;
        padding-top: 70px;

        .fa-icon {
          width: 20%;
          float: left;
          cursor: pointer;
          color: @oroRiva;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Documenti/gridDocMobile.vue